var paper = require('./paper');

var Point = paper.Point;
var Path = paper.Path;
var Tool = paper.Tool;

var startingEvent = new Event("sketch:starting");

/**
 * Builds a canvas countdown graphic.
 * @param  {Element} canvas DOM Element. The canvas Paper.js should draw to.
 * @return {Object}        Hash with one property, "countdown", a function.
 */
var countdownFactory = function (canvas) {
  var paperScope = new paper.PaperScope();
  paper.setup(canvas);

  canvas.dispatchEvent(startingEvent);

  var view = paper.view;
  var currentLayer = paper.project.activeLayer;
  var currentPaths = [];

  var center = view.center;
  var radius = canvas.offsetWidth * 0.55 / 2;
  var meterStrokeWidth = radius * 0.4;
  var meterBGStrokeWidth = radius * 0.7;

  /**
   * Builds meter needle and draws it to canvas.
   * @return {Object} Hash with one property, "rotate", a function.
   */
  var needleFactory = function () {
    var triangle = new Path();

    height = radius;
    width = radius * 0.85;

    var x = width / 2;
    var y = height / 2;

    triangle.add(new Point(center.subtract({x: x, y: y})));
    triangle.add(new Point(center.add({ x: 0, y: y})));
    triangle.add(new Point(center.subtract({x: -x, y: y})));
    triangle.closed = true;
    triangle.translate({x: 0, y: -(radius * 0.9)});

    var origin = triangle.bounds.topCenter;
    var destination = triangle.bounds.bottomCenter;

    triangle.fillColor = {
      gradient: {
          stops: [['#e63530', 0], ['#f2922a', 0.25], ['#fcee32', 1]]
      },
      origin: origin,
      destination: destination
    };
    triangle.strokeWidth = (meterBGStrokeWidth - meterStrokeWidth) / 2;
    triangle.strokeColor = 'black';

    currentPaths.push(triangle);

    return {
      /**
       * Rotates needle around canvas center.
       * @param  {Number} angle Rotational angle. Relative to current rotation.
       * @return {undefined}
       */
      rotate: function (angle) {
        triangle.rotate(-angle, center);
      }
    };
  };


  /**
   * Builds meter graphic and draws it to canvas.
   * @param  {Object} options Options hash
   * @return {Object}         Hash with one property, "render", a function.
   */
  var meterFactory = function (options) {
    var pathOptions = Object.assign({
      strokeColor: "black",
      strokeWidth: meterStrokeWidth,
      strokeCap: "round"
    }, options);

    var path = new Path(pathOptions);

    var arcTo = center.add({
      length: radius,
      angle: 180
    });

    var render = function (percentage) {

      var angle = 0;
      var arcThrough;

      if (percentage > 0) {
        angle = (percentage / 100 * 360);
        arcThrough = angle > 180 ? center.subtract({ angle: 180, length: radius })
                    : center.add({ angle: 180 - angle / 2, length: radius });
      }

      path.segments = [
        center.subtract({
          length: radius,
          angle: -angle
        })
      ];

      if (arcThrough) {
        path.arcTo(arcThrough, arcTo);
      }

      // Put my thing down, flip it and turn it 90 degrees
      path.rotate(90, center);
      path.scale(-1, 1, center);
    };

    currentPaths.push(path);

    return {
      render: render
    };

  };

  // Build our graphics
  var meterOuter = meterFactory({ strokeWidth: meterBGStrokeWidth });
  var meterInner = meterFactory({ strokeColor: "#fff" });
  var needle = needleFactory();

  /**
   * Global render function
   * Renders current state of meter.
   * @param  {Number} percentage  How much meter to render.
   * @param  {Number} needleAngle Angle to rotate needle.
   *                              Relative to needle current position.
   * @return {undefined}
   */
  var render = function (percentage, needleAngle) {
    meterOuter.render(percentage);
    meterInner.render(percentage);
    needle.rotate(needleAngle);
  };

  render(98, 0);

  /**
   * Starts countdown.
   * @param  {Number} time Countdown time, in milliseconds.
   * @return {Promise}      Resolves at end of meter animation.
   */
  var countdown = function (time) {
    var percentage = 97;
    var speed = time !== 0 ? (percentage / time) * 20 : 1;
    var needleAngle = speed * 3.6;

    return new Promise(function (resolve, reject) {
      view.onFrame = function (event) {
        percentage -= speed;
        if (percentage >= 0) {
          percentage = Math.max(Math.min(percentage, 100), 0);
          render(percentage, needleAngle);
        } else {
          view.onFrame = function (e) {};
          resolve("challenge:fail");
        }
      };

      var reset = function () {
        view.onFrame = function () {};
        currentLayer.removeChildren();
        currentPaths.forEach(function (path) {
          path.remove();
        });
        canvas.removeEventListener("sketch:starting", reset);
        resolve("challenge:restarted");
      };

      canvas.addEventListener("sketch:starting", reset);
    });
  };

  paper.view.draw();

  return {
    countdown: countdown
  };
};

module.exports = countdownFactory;
